import {
  CLOSE_CREATE_USER_MODAL,
  OPEN_CREATE_USER_MODAL,
  OPEN_UPDATE_USER_MODAL,
} from "../actions/actionTypes";

const initialState = {
  allUser: [],
  user: null,
  error: null,
  rateerror:[],
  allRates: [],
  allVehicles: [],
  eft:[],
  eftByCompany: {},
  installment:[],
  isCreateUserModalOpen: false,
  selectedUserId: null,
  xmlJson: "",
  xmlJsonUnited: "",
  paymentOptions: {},
  installmentResponses: {},
  vehicleInfo: {},
  allDetails:{},
  underWritingMsg:{},
  loggedInUser: [],
  search_agent: [],
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_INFO_SUCCESS":
      return { ...state, user: action.payload, error: null };
    case "CLEAR_USER_INFO_SUCCESS":
      return { ...state, user: null, error: null };
    case "GET_LOGGED_IN_USER_DATA_SCUCCESS":
      return { ...state, loggedInUser: action.payload, error: null };
  case "SEARCH_AGENT_SUCCESS":
      return { ...state, search_agent: action.payload, error: null };
    case "USER_INFO_FAILURE":
      return { ...state, user: null, error: action.payload };
    case "ALL_USERS_SUCCESS":
      return { ...state, allUser: action.payload, error: null };
    // case "GET_EFT_SUCCESS":
    //   return { ...state, eft: action.payload, error: null };
    case "GET_EFT_SUCCESS":
      // console.log("action.payload.data",action.payload.data)
  return {
    ...state,
    eftByCompany: {
      ...state.eftByCompany,
      [action.payload.companyName]: action.payload.data
    },
    error: null
  };
    case "GET_INSTALLMENT_SUCCESS":
      const uniqueInstallment = [...new Set([...state.installment, action.payload])];
      return { ...state, installment: uniqueInstallment, error: null };
    case "CREATE_USER_SUCCESS":
    case "UPDATE_USER_SUCCESS":
      return {
        ...state,
        allUser: [...state.allUser, ...action.payload],
        error: null,
      };
    case OPEN_CREATE_USER_MODAL:
      return { ...state, isCreateUserModalOpen: true };
    case OPEN_UPDATE_USER_MODAL:
      return {
        ...state,
        isCreateUserModalOpen: true,
        selectedUserId: action.payload,
      };
    case CLOSE_CREATE_USER_MODAL:
      return { ...state, isCreateUserModalOpen: false, selectedUserId: null };
    case "GET_RATE_XML_SUCCESS":
      return { ...state, xmlJson: action.payload, error: null };
    case "GET_RATE_XML_UNITED_SUCCESS":
      return { ...state, xmlJsonUnited: action.payload, error: null };

    case "GET_RATE_XML_ALL_SUCCESS":

  const isDuplicate = state.allRates.some(rate =>
    rate.quoteId === action.payload.quoteId &&
    rate.customerId === action.payload.customerId
  );

  if (isDuplicate) {
    return state; // Return current state if duplicate found
  }

  // If not duplicate, append to array
  return {
    ...state,
    allRates: [...state.allRates, action.payload],
    error: null
  };
    case "GET_RATE_VEHICLE_ALL_SUCCESS":

      // Use a Set to ensure unique rates, then convert back to array
      const uniqueDetails = [...new Set([...state.allVehicles, action.payload])];
      return { ...state, allVehicles: uniqueDetails, error: null };
    //  case "GET_UNDERWRITING_SUCCESS":

    //   // Use a Set to ensure unique rates, then convert back to array
    //   // const msgDetails = [...new Set([...state.underWritingMsg, action.payload])];
    //   return { ...state, underWritingMsg: action.payload, error: null };
    case "GET_UNDERWRITING_SUCCESS":
       const { companyName, messages } = action.payload;
       return {
    ...state,
    // Store messages by company name
    underWritingMsg: {
      ...state.underWritingMsg,
      [companyName]: messages
    },
    error: null
  };

    case "RESET_ALL_RATES":

      return { ...state, allRates: [], installment: [],allVehicles:[] };
    // case "GET_RATE_DETAILED_ALL_SUCCESS":


    //   return {
    //     ...state,
    //     allDetails:action.payload,

    //     error: null
    //   };
    case "GET_RATE_DETAILED_ALL_SUCCESS": {
  const allDetails = action.payload || {};
  const paymentOption = allDetails.paymentOptionResponse || {};
  const installmentResponses = allDetails.installmentResponses || [];
  const vehicleDetails = allDetails.vehicleDetailsResponseList || [];
  const vehicleFees = allDetails.vehicleFeesResponse || {};

  // For allRates - Check duplicates using quoteId + customerId
  const isRateDuplicate = state.allRates.some(rate =>
    rate.quoteId === paymentOption.quoteId &&
    rate.customerId === paymentOption.customerId
  );

  // For allVehicles - Check duplicates using vehicleDetails + vehicleFees
  const isVehicleDuplicate = state.allVehicles.some(v =>
    JSON.stringify(v.vehicleDetailsResponseList) === JSON.stringify(vehicleDetails) &&
    JSON.stringify(v.vehicleFeesResponse) === JSON.stringify(vehicleFees)
  );

  // For installments - Filter existing IDs
  // const existingInstallmentIds = new Set(state.installment.map(i => i.id));
  // const newInstallments = installmentResponses.filter(
  //   inst => !existingInstallmentIds.has(inst.id)
  // );
  const installmentExists = state.installment.some(arr =>
    JSON.stringify(arr) === JSON.stringify(installmentResponses)
  );
  const newInstallment = installmentExists
    ? state.installment
    : [...state.installment, installmentResponses];

  return {
    ...state,
    allDetails: allDetails,
    allRates: isRateDuplicate ?
      state.allRates :
      [...state.allRates, paymentOption],
    allVehicles: isVehicleDuplicate ?
      state.allVehicles :
      [...state.allVehicles, {
        vehicleDetailsResponseList: vehicleDetails,
        vehicleFeesResponse: vehicleFees
      }],
    // installment: [...state.installment, ...newInstallments],
     installment: newInstallment,
    error: null
  };
}


    case "CLEAR_RATE_ERRORS":
      return { ...state, rateerror: [] };
    case "GET_RATE_DETAILED_ALL_FAILURE":
      const uniqueerror = [...new Set([...state.rateerror, action.payload])];
      return { ...state, rateerror: uniqueerror,error:null };
    case "ALL_USERS_FAILURE":
    case "CREATE_USER_FAILURE":
    case "GET_RATE_XML_FAILURE":
    case  "GET_INSTALLMENT_FAILURE":
    case "UPDATE_USER_FAILURE":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default userReducer;
